import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../rootState";
import { initialState } from ".";

const selectSlice = (state: RootState) => state.global || initialState;

export const globalState = createSelector([selectSlice], (global) => {
  return global;
});

export const globalLanguage = createSelector([selectSlice], (global) => {
  return global.lang;
});

export const globalThemeMode = createSelector([selectSlice], (global) => {
  return global.darkMode;
});

export const globalTimezone = createSelector([selectSlice], (global) => {
  return global.timezone;
});
